import { formatDisplayTime, formatRelativeTime } from "../lib/display-time";
import { useRelativeTimeTicker } from "../hooks/useRelativeTimeTicker";

/** Relative time with a full timestamp in the native tooltip; re-renders on a shared ticker. */
export function LiveTimestamp({
  iso,
  timeZone,
  className,
  prefix,
}: {
  iso: string | null | undefined;
  timeZone: string;
  className?: string;
  /** Optional prefix, e.g. "Updated" → "Updated 2m ago". */
  prefix?: string;
}) {
  useRelativeTimeTicker();
  const nowMs = Date.now();
  const relative = formatRelativeTime(iso, nowMs, timeZone);
  const full = formatDisplayTime(iso, timeZone);
  const label = prefix ? `${prefix} ${relative}` : relative;
  return (
    <span className={className} title={full}>
      {label}
    </span>
  );
}
